/* eslint-disable react/jsx-no-bind */
/* eslint-disable max-len */
import { jitsiLocalStorage } from '@jitsi/js-utils';
import jwt_decode from 'jwt-decode';
import React, { useEffect, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';


import {
    accountService,
    callService2,
    meetService,
    userService
} from '../../../../../service';
import { STATUS } from '../../../../../socket/config';
import { SocketContext, useSocket } from '../../../../../socket/socket.context';
import { goToPage, goToRoomWithToken } from '../../../../../utils';
import { Icon, IconArrowLeftNative } from '../../../base/icons';
import { Layout } from '../../../components/web/atoms/Layout';
import { MenuNavigatorPopup } from '../../../components/web/atoms/MenuNavigatorPopup';
import { MenuButtons } from '../../../components/web/molecules/MenuButtons';
import AddContactPopup from '../../../components/web/organisms/AddContactPopup';
import AddExistedContactsModal from '../../../components/web/organisms/AddExistedContactsModal';
import CallReminder from '../../../components/web/organisms/CallReminder';
import CreateGroup from '../../../components/web/organisms/CreateGroup';
import { RecentCall } from '../../../components/web/organisms/RecentCall';
import SchedCall from '../../../components/web/organisms/SchedCall/SchedCall';
import ScheduleCallPopup
    from '../../../components/web/organisms/ScheduleCallPopup';
import { setCallInfo, setCallingDialog, setUserInfo } from '../../../settings';

import SessionChecking from './SessionChecking';

import { Conference } from './index';

interface HomePageProps {}

const HomePage = (props: HomePageProps) => {
    const socketContext = useSocket();

    // Control Menu & Menu Layout
    const [ isOpenMenu, setIsOpenMenu ] = useState(false);
    const [ isOpenMenuLayout, setIsOpenLayout ] = useState(false);
    const [ menuLayout, setMenuLayout ] = useState('');

    // Control Popup & Modal
    const [ isAddContact, setIsAddContact ] = useState(false);
    const [ isOpenSchedCall, setIsOpenSchedCall ] = useState(false);
    const [ isOpenCreateGroup, setIsOpenCreateGroup ] = useState(false);
    const [ isOpenRecentCall, setIsOpenRecentCall ] = useState(false);
    const [ isLoadingCreate, setIsLoadingCreate ] = useState(false);
    const [ userList, setUserList ] = useState([]);
    const [ isInCreateGroup, setIsInCreateGroup ] = useState(false);
    const [ addContactList, setAddContactList ] = useState([]);
    const [ isOpenAddExistedPopup, setIsOpenAddExistedPopup ] = useState(false);
    const dataNewGroup = useSelector(state => state['features/base/app/group'].groupData);
    const dispatch = useDispatch();
    const [ selectedUserList, setSelectedUserList ] = useState([]);

    const { user, callDialog, callInfo, scheduleCallDialog, scheduleCallInfo } = useSelector(state => state['features/settings']);
    const token = jitsiLocalStorage.getItem('token');
    const isKeepDnd = JSON.parse(jitsiLocalStorage.getItem('isKeepDnd'));
    const { isOpen: isChatOpen } = useSelector(state => state['features/chat']);


    const { room } = useSelector(state => {
        return {
            room: state['features/base/conference'].room
        };
    });
    const handleOpenSchedCall = list => {
        setIsOpenSchedCall(true);
        setUserList(list);
    };
    const handleOpenRecentCall = () => {
        // setIsOpenRecentCall(!isOpenRecentCall);
        setMenuLayout('recent-call');
        handleChangeMenu('recent-call');
    };

    const handleChangeMenu = value => {
        setMenuLayout(value);
        setIsOpenLayout(Boolean(value));
        setIsOpenSchedCall(false);
        setIsOpenRecentCall(false);
        setIsAddContact(false);
        setIsOpenCreateGroup(false);
    };
    const handleChangeMenuMobile = value => {
        setMenuLayout(value);
        setIsOpenLayout(Boolean(value));
        setIsOpenSchedCall(false);
        setIsOpenRecentCall(false);
        setIsAddContact(false);
        setIsOpenCreateGroup(false);
        setIsOpenMenu(true);
    };
    const handleOpenCreateGroup = data => {
        setSelectedUserList(data);
        setIsOpenCreateGroup(true);
    };
    const handleSubmitAddExistedContacts = contacts => {
        const list = contacts.filter(item => item.isContact);

        setAddContactList(list);
    };
    const onSubmitAddContactList = async userInfo => {
        const raw = [ ...addContactList ];

        if (isInCreateGroup) {
            raw.push(userInfo);
            setAddContactList(raw);
            setIsAddContact(false);
        } else {
            setIsLoadingCreate(true);
            try {
                await accountService.addNewContact(userInfo)
                    .then(async () => {
                        const res = await accountService.getDataContact();

                        dispatch({
                            type: 'USER_CONTACT',
                            value: res
                        });
                    });
            } catch (e) {
                console.log(e);
            } finally {
                setIsLoadingCreate(false);
                setIsAddContact(false);
            }
        }
    };

    const removeAddContactItem = (key, item) => {
        const raw = [ ...addContactList ];

        raw.splice(key, 1);
        setAddContactList(raw);
        const list = [ ...selectedUserList ];
        const itemIndex = list.findIndex(con => con.id === item.id);
        const contact = list.filter(c => c.id === item.id);

        const newRawContact = { ...contact[0],
            isContact: !contact[0].isContact };


        list.splice(itemIndex, 1, newRawContact);

        setSelectedUserList(list);
    };
    const createNewGroup = async data => {
        setIsLoadingCreate(true);
        try {
            socketContext.createGroup(data);
        } catch (e) {
            console.log(e);
        } finally {
            setIsLoadingCreate(false);
            setAddContactList([]);
            setIsOpenCreateGroup(false);
        }


    };
    const getUser = async () => {
        let currentDnd = JSON.parse(jitsiLocalStorage.getItem('isKeepDnd'));
        try {
            const data = await userService.getUserInfo()
                .then(res => {
                    dispatch(setUserInfo(res));
                    socketContext.socketInit(res);
                    socketContext.onStatus();
                    socketContext.onCall(res);
                    socketContext.onScheduleCall(res);
                    if (!room && currentDnd) {
                        setIsOpenMenu(false);
                        setMenuLayout('disturb');
                        socketContext.sendUserStatus(res.id, STATUS.DND);
                    } else if (room) {
                        setIsOpenMenu(true);
                        socketContext.sendUserStatus(res.id, STATUS.BUSY);
                    } else {
                        socketContext.sendUserStatus(res.id, STATUS.ONLINE);
                    }
                });
        } catch (e) {
            // jitsiLocalStorage.removeItem('token');
            // dispatch(setUserInfo());
            // goToPage('/');
        }
    };

    const handleAcceptCall = async () => {
        // const roomId = callInfo.isGroupCall ? callInfo.callerData.userId : callInfo.objectId;
        const roomId = callInfo.objectId;
        const objectId = callInfo.objectId;

        socketContext.sendUserStatus(user.id, STATUS.BUSY);
        dispatch(setCallingDialog(false));
        await callService2.joinCall(objectId);
        const meeting = await meetService.createMeeting(roomId, `${user.firstName} ${user.lastName}`, user.email, user.id);
        const meetingrest = await meetService.getMeetingData(meeting?.data?.id);

        goToRoomWithToken(meetingrest.authRoom, meetingrest.token);
    };
    const handleRejectCall = async () => {
        const roomId = callInfo.objectId;

        dispatch(setCallingDialog(false));
        dispatch(setCallInfo());
        await callService2.rejectCall(roomId);
    };
    const closeCallingDialog = () => {
        dispatch(setCallingDialog(false));
    };
    const changeUserStatus = (id, status) => {
        socketContext.sendUserStatus(id ?? user.id, status);
    };
    const validateJwtToken = jwtToken => {
        try {
            const { exp } = jwt_decode(jwtToken);

            if (exp < (new Date().getTime() + 1) / 1000) {
                return false;
            }
        } catch (err) {
            return false;
        }

        return true;


    };
    const isValidInviteUrl = () => {
        const urlSearchParams = new URLSearchParams(window.location.search);

        // console.log('urlSearchParams', urlSearchParams.get('room'), urlSearchParams.get('jwt'));
        let validURL = true;

        if (!urlSearchParams.get('room')) {
            validURL = false;
        }
        if (!urlSearchParams.get('jwt')) {
            validURL = false;
        }
        if (urlSearchParams.get('jwt') && !validateJwtToken(urlSearchParams.get('jwt'))) {
            validURL = false;
        }
        console.log('validURL', validURL);

        return validURL;
    };

    useEffect(() => {
        if (isValidInviteUrl()) {

        }
        getUser();
        const interval = setInterval(() => {
            getUser();
          }, 60000);
          return () => clearInterval(interval); 
    }, []);
    useEffect(() => {
        if (isValidInviteUrl()) {
            return;
        }
        if (!token) {
            goToPage('/');
        }
    }, [ token ]);
    useEffect(() => {
        const raw = [ ...selectedUserList ];

        addContactList.map(item => {

            const index = selectedUserList.findIndex(list => list.id === item.id);

            raw.splice(index, 1, item);
            setSelectedUserList(raw);
        });
    }, [ addContactList ]);
    const toggleMenuPopup = () => {
        setMenuLayout('');
    };


    return (
        <SocketContext.Provider
            value = {{
                ...socketContext,
                changeUserStatus }}>
            <div
                className = { 'home' }
                id = { 'home-page' }
                style = {{ minHeight: window.innerHeight }}>
                <div className = { 'menu-and-sched-call' }>
                    <div className = { 'new-top-button' }>
                        {menuLayout.length && !isOpenMenu ? <div
                            className = { `conference-left-menu-buttons--left-button-new ${isChatOpen ? 'chat-opened' : ''}` }
                            onClick = { () => {
                                setIsOpenMenu(false);
                                setMenuLayout('');
                                handleChangeMenu('');
                                setIsAddContact(false);
                                setIsOpenCreateGroup(false);
                                setAddContactList([]);
                            } }>
                            <Icon
                                color = { '#FFF' }
                                size = { 25 }
                                src = { IconArrowLeftNative } />
                        </div> : <div />}
                    </div>
                    {
                        !isOpenMenu && <div className = { 'conference-left-menu-buttons' }>
                            <div
                                className = { `${isOpenMenu ? 'conference-menu-hide' : 'conference-menu-show'}` }>
                                <div className = { 'conference-buttons' }>
                                    <MenuButtons
                                        isHideMenu = { isOpenMenu }
                                        isRoom = { Boolean(room) }
                                        onChange = { handleChangeMenu }
                                        value = { menuLayout } />
                                </div>
                            </div>
                        </div>
                    }
                    {
                        !isOpenMenu && <div className = { 'conference-left-menu-buttons-mobile' }>
                            <div
                                className = { `${isOpenMenu ? 'conference-menu-hide' : 'conference-menu-show'}` }>
                                <div className = { 'conference-buttons' }>
                                    <MenuButtons
                                        isHideMenu = { isOpenMenu }
                                        isRoom = { Boolean(room) }
                                        onChange = { handleChangeMenuMobile }
                                        value = { menuLayout } />
                                </div>
                            </div>
                        </div>
                    }
                    {<div
                        className = { `conference-left-menu-buttons--left-button ${isOpenMenu ? '' : 'btn-close-menu'} ${isChatOpen ? 'chat-opened' : ''}` }
                        onClick = { () => {
                            setIsOpenMenu(!isOpenMenu);
                        } }>
                        <Icon
                            color = { '#FFF' }
                            size = { 25 }
                            src = { IconArrowLeftNative }
                            style = {{ transform: `rotate(${isOpenMenu ? 180 : 0}deg)` }} />
                    </div>}
                </div>
                {isOpenMenuLayout && <div>
                    <MenuNavigatorPopup
                        addContactList = { addContactList }
                        dataNewGroup = { dataNewGroup }
                        isOpenMenu = { isOpenMenu }
                        menuActive = { menuLayout }
                        openAddContact = { () => {
                            setIsAddContact(true);
                            setIsInCreateGroup(false);
                        } }
                        openCreateGroup = { handleOpenCreateGroup }
                        openRecentCall = { handleOpenRecentCall }
                        openSchedCall = { list => handleOpenSchedCall(list) }
                        selectedUserList = { selectedUserList }
                        toggleMenuPopup = { toggleMenuPopup } />

                    {isOpenRecentCall && <div className = { 'conference-recent-call' }>
                        <RecentCall
                            onChange = { handleOpenSchedCall }
                            onClose = { () => setIsOpenRecentCall(false) } /></div>}

                    {
                        isOpenSchedCall && <div className = { 'conference-left-menu-buttons--schedcall' }>
                            <SchedCall
                                onClose = { () => setIsOpenSchedCall(false) }
                                user = { user }
                                value = { userList } />
                        </div>
                    }
                    {
                        <CreateGroup
                            addContactList = { addContactList }
                            isOpen = { isOpenCreateGroup }
                            isOpenAddContactPopup = { isAddContact }
                            isOpenAddExistedPopup = { isOpenAddExistedPopup }
                            onClose = { () => {
                                setIsOpenCreateGroup(false);
                                setAddContactList([]);
                            } }
                            onSave = { createNewGroup }
                            openAddExistedContactsModal = { () => {
                                setIsOpenAddExistedPopup(true);
                                setIsInCreateGroup(true);
                            } }
                            removeAddContactItem = { removeAddContactItem } />
                    }
                    {isAddContact && <div className = { 'conference-left-menu-buttons--add-contact-popup' }>
                        <AddContactPopup
                            isInCreateGroup = { isInCreateGroup }
                            isLoading = { isLoadingCreate }
                            isOpen = { isAddContact }
                            onClose = { () => setIsAddContact(false) }
                            onSave = { onSubmitAddContactList } />
                    </div> }
                    {
                        isOpenAddExistedPopup && <div className = { 'conference-left-menu-buttons--add-contact-popup' }>
                            <AddExistedContactsModal
                                addContactList = { addContactList }
                                handleSubmitAddExistedContacts = { handleSubmitAddExistedContacts }
                                onClose = { () => setIsOpenAddExistedPopup(false) }
                                selectedUserList = { selectedUserList } />
                        </div>
                    }
                </div>}
                {
                    scheduleCallDialog && <ScheduleCallPopup
                        scheduleCallInfo = { scheduleCallInfo } />
                }
                {
                    callDialog && !isKeepDnd && <CallReminder
                        callInfo = { callInfo }
                        closeCallingDialog = { closeCallingDialog }
                        onAcceptCall = { handleAcceptCall }
                        onRejectCall = { handleRejectCall } />
                }
                <div
                    className = { room ? 'wrapper-home' : 'home-page-logo wrapper-home' }
                    id = { 'videoconference_page' }
                    onClick = { menuLayout === 'disturb' ? null : () => {
                        setIsOpenLayout(false);
                        setIsOpenMenu(true);
                    } }>
                    {room
                        ? <Conference />
                        : <Layout
                            isNotDisturb = { menuLayout === 'disturb' } />}
                </div>
                {
                    callDialog && !isKeepDnd && <CallReminder
                        callInfo = { callInfo }
                        closeCallingDialog = { closeCallingDialog }
                        onAcceptCall = { handleAcceptCall }
                        onRejectCall = { handleRejectCall } />
                }
                {/* <SessionChecking /> */}
            </div>
        </SocketContext.Provider>
    );
};

export default HomePage;
